import React from "react";
import CreatePassword from "../../components/createPassword/CreatePassword";

const CreatePasswordScreen: React.FC = () => {
  return <CreatePassword />;
};

export default CreatePasswordScreen;
